export const schema = {
  properties: {
    id: {
      type: 'string',
      title: 'Id',
      hidden: true
    },
    active: {
      type: 'string',
      title: 'active',
      hidden: true
    },
    name: {
      type: 'string',
      title: 'Name',
      sortable: true
    },
    sourceReference: {
      type: 'string',
      title: 'Import company',
      sortable: true
    },
    actions: {
      type: 'object',
      title: 'Actions',
      properties: {
        deleteAction: {
          type: 'string',
          format: 'button',
          title: 'Delete',
          icon: '#delete_sign',
          color: 'danger'
        },
        editAction: {
          type: 'string',
          format: 'button',
          title: 'Edit',
          icon: '#edit',
          color: 'secondary'
        }
      }
    }
  }
}
